import { InputBase, InputBaseProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { typography12RegularStyle } from 'src/legacy/components/Text';
import { black, DividersAndCardBorders } from 'src/theme/colors';

interface InputStylesProps {
  width?: number | string;
}
const useStyles = makeStyles<InputStylesProps>()((theme, props) => ({
  root: {
    padding: 0,
    width: props.width || 223,
    borderBottom: `1px solid ${DividersAndCardBorders}`,
    '& input': {
      ...typography12RegularStyle,
      padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
      borderRadius: 4,
      height: 'auto',
      '&::placeholder': {
        color: black,
      },
    },
  },
}));

export const BaseMenuInput: React.FC<InputBaseProps & InputStylesProps> =
  React.forwardRef((props, ref) => {
    const { classes } = useStyles({ width: props.width });
    return <InputBase className={classes.root} ref={ref} {...props} />;
  });
